import Button from "./button.component.js";

export default angular
    .module("oui.button", [])
    .component("ouiButton", Button)
    .name;
